// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.active-revert-container {
    width: 100%;
    margin: 0;
}

.active-revert-container .title {
    margin: 0 auto 10px;
}

.active-revert-container form {
    background-color: #0e0f15;
    color: white;
    width: 100%;
    border: 2px solid #f09502;
    padding: 40px !important;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
}

.active-revert-container form > div {
    width: 100%;
}

.active-revert-container form label {
    margin-bottom: 3px;
    font-size: small;
}

.errorInput {
    background-color: rgb(255, 196, 196);
}

@media (max-width: 500px) {
    .active-revert-container .title {
        margin: 15px auto 6px;
    }

    .active-revert-container form {
        padding: 8px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/revert-payments/revert-payments/revert-payments.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.active-revert-container {\n    width: 100%;\n    margin: 0;\n}\n\n.active-revert-container .title {\n    margin: 0 auto 10px;\n}\n\n.active-revert-container form {\n    background-color: #0e0f15;\n    color: white;\n    width: 100%;\n    border: 2px solid #f09502;\n    padding: 40px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.active-revert-container form > div {\n    width: 100%;\n}\n\n.active-revert-container form label {\n    margin-bottom: 3px;\n    font-size: small;\n}\n\n.errorInput {\n    background-color: rgb(255, 196, 196);\n}\n\n@media (max-width: 500px) {\n    .active-revert-container .title {\n        margin: 15px auto 6px;\n    }\n\n    .active-revert-container form {\n        padding: 8px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
